import {CanActivateFn, Router} from '@angular/router';
import {TableNumberService} from "../http/table-number.service";
import {inject} from "@angular/core";
import {MatSnackBar} from "@angular/material/snack-bar";

export const checkoutBlockGuard: CanActivateFn = (route, state) => {
  const tableNumberService = inject(TableNumberService);
  const router = inject(Router);
  const _snackBar = inject(MatSnackBar);

  if (tableNumberService.isInCheckoutFlow()) {
    _snackBar.open('Bitte zuerst Bestellung und Rechnung abschließen.', 'Schließen', {duration: 3000});
    return router.parseUrl('/checkout');
  }

  return true;
};
